module.exports = __webpack_public_path__ + "img/yiqing.a1dbd769.png";